var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNqrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-qrcode"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2813",
    "data-name": "Group 2813",
    transform: "translate(-366 -791)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(366 791)",
    fill: "#cecece",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-qrcode-2",
    "data-name": "Icon awesome-qrcode",
    d: "M0,9.57H7.32V2.25H0ZM2.44,4.69H4.88V7.13H2.44ZM9.76,2.25V9.57h7.32V2.25Zm4.88,4.88H12.2V4.69h2.44ZM0,19.329H7.32V12.01H0Zm2.44-4.88H4.88v2.44H2.44Zm13.419-2.44h1.22v4.88h-3.66v-1.22H12.2v3.66H9.76V12.01h3.66v1.22h2.44Zm0,6.1h1.22v1.22h-1.22Zm-2.44,0h1.22v1.22h-1.22Z",
    transform: "translate(376.762 800.211)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 366, 791)",
    filter: "url(#Icon_awesome-qrcode)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-qrcode-3",
    "data-name": "Icon awesome-qrcode",
    d: "M0,9.57H7.32V2.25H0ZM2.44,4.69H4.88V7.13H2.44ZM9.76,2.25V9.57h7.32V2.25Zm4.88,4.88H12.2V4.69h2.44ZM0,19.329H7.32V12.01H0Zm2.44-4.88H4.88v2.44H2.44Zm13.419-2.44h1.22v4.88h-3.66v-1.22H12.2v3.66H9.76V12.01h3.66v1.22h2.44Zm0,6.1h1.22v1.22h-1.22Zm-2.44,0h1.22v1.22h-1.22Z",
    transform: "translate(10.76 9.21)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNqrIcon);
export default __webpack_public_path__ + "static/media/nqr-icon.8d687d2524b291fea42369e6bbf4dc10.svg";
export { ForwardRef as ReactComponent };